<template>
    <div>
        <button
            :disabled="botaoDesativado"
            @click="abrirDialogoConfirmacaoSolicitarAssinatura()">
            {{ textoBotao }}
        </button>
      <mensagem-confirmacao
          :tamanhoMaximo="'350'"
          :exibirMensagem="mostrarDialogoConfirmacaoSolicitarAssinatura"
          :titulo="textoBotao"
          :textoSecundario="`Deseja realmente ${textoBotao.toLowerCase()}?`"
          @confirmado="confirmar"
          @recusado="fecharDialogoConfirmacaoSolicitarAssinatura"/>
    </div>
</template>

<script>
import MensagemConfirmacao from "@/commons/components/MensagemConfirmacao.vue";

export default {
    name: 'BotaoSolicitarAssinatura',
  components: {MensagemConfirmacao},
    props: {
      statusAssinatura: {
        type: String,
        required: true
      }
    },
    data() {
        return {
            mostrarDialogoConfirmacaoSolicitarAssinatura: false
        }
    },
    computed: {
      textoBotao() {
        switch (this.statusAssinatura) {
          case 'ASSINADO':
            return 'Documento Assinado'
          case 'ENVIADO':
            return 'Assinatura Solicitada'
          default:
            return 'Solicitar Assinatura'
        }
      },
      botaoDesativado() {
        return this.statusAssinatura === 'ENVIADO' || this.statusAssinatura === 'ASSINADO'
      }
    },
    methods: {
        abrirDialogoConfirmacaoSolicitarAssinatura(){
          if (!this.botaoDesativado) {
            this.mostrarDialogoConfirmacaoSolicitarAssinatura = true
          }
        },
        fecharDialogoConfirmacaoSolicitarAssinatura(){
            this.mostrarDialogoConfirmacaoSolicitarAssinatura = false
        },
        confirmar(){
            this.fecharDialogoConfirmacaoSolicitarAssinatura()
            this.$emit('confirmarSolicitacao')
        }
    }
}
</script>